export enum PaymentStartStage {
  PAYMENT = "PAYMENT",
  NO_PAYMENT = "NO_PAYMENT",
  PAYMENT_PIN = "PAYMENT_PIN",
  PAYMENT_CVV = "PAYMENT_CVV",
  DCB_OTP = "DCB_OTP",
  DCB_SMS = "DCB_SMS",
  PAYMENT_RESULT = "PAYMENT_RESULT",
  THREE_D = "THREE_D"
}
